var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frame baseMap"},[_c('div',{staticClass:"detail"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"one"},[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{staticClass:"two"},[_vm._v(_vm._s(_vm.detail.subTitle))])]),_c('div',{staticClass:"rich",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }